import http from "../plugins/axios"

export const getTutorSchedule = async (scheduleId, eventId) => {
  try {
    let response = await http.get(`/tutors`, { params: { schedule: scheduleId } })
    
    if (response.data?.data?.length === 0 && eventId) {
      response = await http.get(`/tutors`, { params: { event: eventId } })
    }
    
    return response.data
  } catch (error) {
    throw error
  }
}